import { useQuery } from "@tanstack/react-query";
import { VenueFragment } from "./fragments/venue";
import { useVenueId } from "~/store";
import {
	GetCurrentVenueDocument,
	GetCurrentVenueQuery,
	GetCurrentVenueQueryVariables,
} from "~/types/__generated/gql/graphql";
import { validateSessionFromUrl } from "~/utils/validate-session-from-url";
import { gqlReq } from "~/libs/gql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		query GetCurrentVenue {
			getCurrentVenue {
				...VenueFragment
			}
		}
		${VenueFragment}
	`
);

export const getCurrentVenueQueryKey = () => ["venue"];

export const useGetCurrentVenue = () => {
	const venueId = useVenueId();

	return useQuery({
		enabled: !!venueId,
		queryKey: getCurrentVenueQueryKey(),
		queryFn: async ({ signal }) => {
			const { isSessionExpired, isPathnameSessionSensitive } =
				validateSessionFromUrl();

			if ((isPathnameSessionSensitive() && isSessionExpired()) || !venueId)
				return Promise.resolve(undefined);

			const venue = await gqlReq<
				GetCurrentVenueQuery,
				GetCurrentVenueQueryVariables
			>({
				document: GetCurrentVenueDocument,
				signal,
			});

			return venue;
		},
	});
};

export const getCurrentVenueCache = () => {
	return queryClient.getQueryData<GqlResultOf<GetCurrentVenueQuery>>(
		getCurrentVenueQueryKey(),
	);
};
